var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1062_3886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 11.4583C5.55033 11.4583 1.66699 12.4333 1.66699 14.375V15.8333H13.3337V14.375C13.3337 12.4333 9.45033 11.4583 7.50033 11.4583ZM3.61699 14.1667C4.31699 13.6833 6.00866 13.125 7.50033 13.125C8.99199 13.125 10.6837 13.6833 11.3837 14.1667H3.61699ZM7.50033 9.99999C9.10866 9.99999 10.417 8.69166 10.417 7.08332C10.417 5.47499 9.10866 4.16666 7.50033 4.16666C5.89199 4.16666 4.58366 5.47499 4.58366 7.08332C4.58366 8.69166 5.89199 9.99999 7.50033 9.99999ZM7.50033 5.83332C8.19199 5.83332 8.75033 6.39166 8.75033 7.08332C8.75033 7.77499 8.19199 8.33332 7.50033 8.33332C6.80866 8.33332 6.25033 7.77499 6.25033 7.08332C6.25033 6.39166 6.80866 5.83332 7.50033 5.83332ZM13.367 11.5083C14.3337 12.2083 15.0003 13.1417 15.0003 14.375V15.8333H18.3337V14.375C18.3337 12.6917 15.417 11.7333 13.367 11.5083ZM12.5003 9.99999C14.1087 9.99999 15.417 8.69166 15.417 7.08332C15.417 5.47499 14.1087 4.16666 12.5003 4.16666C12.0503 4.16666 11.6337 4.27499 11.2503 4.45832C11.7753 5.19999 12.0837 6.10832 12.0837 7.08332C12.0837 8.05832 11.7753 8.96666 11.2503 9.70832C11.6337 9.89166 12.0503 9.99999 12.5003 9.99999Z",
    fill: "#3C3C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1062_3886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.c9c7a205b92c212b9ee22e3633e53b29.svg";
export { ForwardRef as ReactComponent };